// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70178":"dcb16172","74372":"7e6afa7d"}[chunkId] + ".chunk.css";
};